export const currencies = [
  { code: "USD", symbol: "$", description: "United States Dollar" },
  { code: "EUR", symbol: "€", description: "European Euro" },
  { code: "GBP", symbol: "£", description: "British Pound Sterling" },
  { code: "DKK", symbol: "kr", description: "Danish Krone" },
  { code: "AED", symbol: "AED", description: "United Arab Emirates Dirham" },
  { code: "AUD", symbol: "$", description: "Australian Dollar" },
  { code: "BRL", symbol: "R$", description: "Brazilian Real" },
  { code: "CAD", symbol: "$", description: "Canadian Dollar" },
  { code: "CHF", symbol: "fr", description: "Swiss Franc" },
  { code: "CNY", symbol: "¥", description: "Chinese Yuan" },
  { code: "CZK", symbol: "Kč", description: "Czech Koruna" },
  { code: "EGP", symbol: "E£", description: "Egyptian Pound" },
  { code: "HKD", symbol: "$", description: "Hong Kong Dollar" },
  { code: "HUF", symbol: "Ft", description: "Hungarian Forint" },
  { code: "ILS", symbol: "₪", description: "Israeli New Shekel" },
  { code: "INR", symbol: "₹", description: "Indian Rupee" },
  { code: "JPY", symbol: "¥", description: "Japanese Yen" },
  { code: "KRW", symbol: "₩", description: "South Korean Won" },
  { code: "MXN", symbol: "$", description: "Mexican Peso" },
  { code: "NOK", symbol: "kr", description: "Norwegian Krone" },
  { code: "PLN", symbol: "zł", description: "Polish Zloty" },
  { code: "SEK", symbol: "kr", description: "Swedish Krone" },
  { code: "SGD", symbol: "S$", description: "Singapore Dollar" },
  { code: "TRY", symbol: "₺", description: "Turkish Lira" },
  { code: "ZAR", symbol: "R", description: "South African Rand" },
];
